
import {Component, Input, EventEmitter, Output} from '@angular/core';

@Component({
  selector: 'calendar-with-date-type',
  templateUrl: './calendar-with-date-type.component.html',
  styleUrls: ['./calendar-with-date-type.component.css']
})
export class CalendarWithDateTypeComponent {

  @Input() question_index : number;
  @Input() question_name : string;
  @Input() question_name_second : string;
  @Input() is_mandt : boolean;
  @Output() user_Resp = new EventEmitter<string[]>();
  @Input() userRes : string[];
  @Input() indexOfRepeater : number;
  @Input() question_number : number;
  @Input() is_range : number;

  response:string;
  date:Date;
  responseMax:string;

  ngOnInit(){
  }
  
  clicked(event : any){
    this.date = new Date(event.value);
    let selectedYear          = this.date.getFullYear();
    let selectedMonthIndex    = this.date.getMonth() + 1;
    let selectedDate          = this.date.getDate() ;
    this.response = selectedDate + "/" + selectedMonthIndex + "/" + selectedYear;
    if(this.is_range){
      this.user_Resp.emit([this.indexOfRepeater.toString(),this.question_number.toString(),this.response + " - " + (this.responseMax != undefined ? this.responseMax : 'NA')]);
    }
    else{
      this.user_Resp.emit([this.indexOfRepeater.toString(),this.question_number.toString(),this.response]);
    }
  }

  clickedMax(event : any){
    var date = new Date(event.value);
    this.responseMax = date.getDate() + "/" + date.getMonth() + 1 + "/" + date.getFullYear();
    this.user_Resp.emit([this.indexOfRepeater.toString(),this.question_number.toString(),this.response + " - " + this.responseMax]);
  }
}


// WEBPACK FOOTER //
// ./src/app/questions-type/calendar-with-date-type/calendar-with-date-type.component.ts